import { NgModule } from '@angular/core';
import { WelcomeUserComponent } from './welcome-user.component';
import { COMMON_MODULES } from '../../constants/common-modules';

@NgModule({
  declarations: [WelcomeUserComponent],
  imports: [...COMMON_MODULES],
  exports: [WelcomeUserComponent],
})
export class WelcomeUserModule {}
